import Vue from 'vue';
import Customers from '@/plugins/graphql/queries/v2/ecommerce/customers-by-segment.gql';
import { PageRecipientSegmentModel } from '@/helpers/entities/models/PageRecipientSegmentModel';
export default Vue.extend({
    apollo: {
        pageRecipients: {
            query: Customers,
            variables() {
                return {
                    appUuid: this.appUuid,
                    appSegmentationUuid: this.appSegmentationUuid,
                };
            },
            update(data) {
                const recipients = data.ecommerceRecipientsBySegment.edges;
                const recipientNode = (recipient) => {
                    return new PageRecipientSegmentModel(recipient.node);
                };
                return recipients.map(recipientNode);
            },
        },
    },
    props: {
        appUuid: {
            type: String,
            required: true,
        },
        appSegmentationUuid: {
            type: String,
            default: null,
        },
        segmentationName: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            pageRecipients: [],
        };
    },
    computed: {
        dataForCsv() {
            const self = this;
            if (self.pageRecipients.length >= 1) {
                return self.pageRecipients.map((recipient) => {
                    return {
                        id: recipient.id,
                        name: recipient.name,
                        profilePic: recipient.profilePic,
                        platformOrigin: self.toTitleCase(recipient.platformOrigin),
                        segmentName: self.toTitleCase(self.segmentationName),
                    };
                });
            }
            return [];
        },
    },
    methods: {
        toTitleCase(text) {
            return text
                .toLowerCase()
                .split(' ')
                .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                .join(' ');
        },
    },
    render() {
        if (this.$scopedSlots.default) {
            const self = this;
            return this.$scopedSlots.default({
                pageRecipients: self.dataForCsv,
            });
        }
    },
});
